import { c as _c } from "react/compiler-runtime";
import { readCurrencyFragment } from "@opensea/app-kit";
import { graphql, useQuery } from "@opensea/graphql";
import { FlexColumn, List } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { useBalances } from "../../../../../providers/BalancesProvider";
import { ViewWalletPortfolioValue, ViewWalletPortfolioValueSkeleton } from "../../ViewWalletPortfolioValue";
import { ViewWalletPortfolioValueFragment } from "../../ViewWalletPortfolioValue.fragment";
import { CryptoTabActions } from "./CryptoTabActions";
import { CurrencyBalanceItem, CurrencyBalanceItemSkeleton } from "./CurrencyBalanceItem";
export const CryptoTabQuery = graphql(`
    query CryptoTabQuery($address: Address!) {
      profileByAddress(address: $address) {
        __typename
        ... on Profile {
          portfolioSummary {
            estimatedTokenValue {
              ...ViewWalletPortfolioValue
            }
          }
        }
      }
    }
  `, [ViewWalletPortfolioValueFragment]);
export function CryptoTab(t0) {
  const $ = _c(18);
  const {
    address,
    isProfileOwner
  } = t0;
  const t = useTranslations("wallet.CryptoTab");
  const {
    balances
  } = useBalances();
  let t1;
  if ($[0] !== address) {
    t1 = {
      query: CryptoTabQuery,
      variables: {
        address
      }
    };
    $[0] = address;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [t2] = useQuery(t1);
  const {
    data
  } = t2;
  if (!data?.profileByAddress || data.profileByAddress.__typename !== "Profile") {
    let t3;
    if ($[2] !== t) {
      t3 = t("errorMessage");
      $[2] = t;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== t3) {
      t4 = <>{t3}</>;
      $[4] = t3;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    return t4;
  }
  let t3;
  if ($[6] !== data.profileByAddress.portfolioSummary.estimatedTokenValue) {
    t3 = <ViewWalletPortfolioValue portfolioValue={data.profileByAddress.portfolioSummary.estimatedTokenValue} />;
    $[6] = data.profileByAddress.portfolioSummary.estimatedTokenValue;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isProfileOwner) {
    t4 = isProfileOwner && <CryptoTabActions />;
    $[8] = isProfileOwner;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== balances) {
    t5 = balances.map(_temp);
    $[10] = balances;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <List className="bg-transparent" showBorder={false}>{t5}</List>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t4 || $[16] !== t6) {
    t7 = <FlexColumn className="gap-6 px-4 lg:px-6">{t3}{t4}{t6}</FlexColumn>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
function _temp(balance) {
  return <CurrencyBalanceItem currency={readCurrencyFragment(balance.currency)} key={balance.id} quantity={balance.quantity} usdValue={balance.usdValue} variant="24h" withLink={true} />;
}
export function CryptoTabSkeleton(t0) {
  const $ = _c(6);
  const {
    isProfileOwner
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ViewWalletPortfolioValueSkeleton />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isProfileOwner) {
    t2 = isProfileOwner && <CryptoTabActions />;
    $[1] = isProfileOwner;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <List className="bg-transparent" showBorder={false}><CurrencyBalanceItemSkeleton /><CurrencyBalanceItemSkeleton /><CurrencyBalanceItemSkeleton /><CurrencyBalanceItemSkeleton /></List>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <FlexColumn className="gap-6 px-4 lg:px-6">{t1}{t2}{t3}</FlexColumn>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}